import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";


type DocumentoProps = {
  onActionEdit: (idDocumento: number | undefined) => void,
  onActionDelete: (idDocumento: number | undefined) => void,
  onDownload: (idFuncionarioArquivo: number, imageName: string) => void,
};

export const GenerateDocumentoColumnsDefinition = ({
  onActionEdit,
  onActionDelete,
  onDownload,
}: DocumentoProps): GridColDef[] => {
  const computeItemSituacaoTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Atual";
      case 1:
        return "Obsoleto";
      default:
        return "?";
    }
  };

  const computeItemSituacaoColor = (status: number) => {
    switch (status) {
      case 0:
        return "#45b6af";
      case 1:
        return "#f3565d";
      default:
        return "blue";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 80,
      flex: 0,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        const dataVencimento = params.row.dataVencimento;
        if (!dataVencimento) return null;
        const hoje = dayjs();
        const dataDoc = dayjs(dataVencimento);
        const isVencido = dataDoc.isBefore(hoje, 'day');
        const title = isVencido ? "V" : "E";
        const color = isVencido ? "red" : "green";
        const description = isVencido ? "Vencido" : "Em dia";

        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <ItemStatus
              title={title}
              color={color}
              description={description}
            />
          </div>
        );
      }
    },
    {
      field: "situacao",
      filterable: false,
      headerName: "Situação",
      flex: 0,
      minWidth: 80,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
          <div>
            <span
              className='inline px-2 py-1 text-sm rounded'
              style={{ backgroundColor: computeItemSituacaoColor(params.value) }}>
              {computeItemSituacaoTitle(params.value)}
            </span>
          </div>
        </div>
      )
    },
    {
      field: "dataVencimento",
      filterable: false,
      headerName: "Data de vencimento",
      minWidth: 150,
      flex: 0,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">{params.value !== null && dayjs(params.value).format('DD/MM/YYYY')}</div>
        );
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Nome do documento",
      minWidth: 150,
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
   {
      field: "nome",
      filterable: false,
      headerName: "Arquivo",
      minWidth: 150,
      flex: 1,       
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        arquivoNome: rows['nome'],
        idDocumento: rows['idDocumento'],
      }),
      renderCell: (params) => {
        const maxSize = 100; 
        const arquivoNome = params.value['arquivoNome'] as string;
        const idDocumento = params.value['idDocumento'] as number;

        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <Button
              onMouseDown={() => onDownload(idDocumento, arquivoNome)}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.3rem solid #45b6af',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
                width: '100%', 
                justifyContent: 'flex-start', 
                textTransform: 'none', 
              }}>
              {arquivoNome && arquivoNome.length > maxSize ? `${arquivoNome.substring(0, maxSize)}...` : arquivoNome}
            </Button>
          </div>
        );
      },
    },
    {
      field: 'idDocumento',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 0,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}

